<template>
    <chip-informative v-bind="$attrs" big>
        {{ label }}
    </chip-informative>
</template>

<script setup lang="ts">
    import { ChipInformative } from '@keyvue/one-ui';
    import { computed } from 'vue';
    import { formatMoney } from '@/shared/utils/money';

    const props = defineProps<{
        price: number | string
    }>();

    const label = computed(() => {
        if (typeof props.price === 'string') {
            return props.price;
        }

        if (props.price === 0) {
            return 'Gratis';
        }

        return formatMoney(props.price, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
    });
</script>
